import React from 'react';
import PropTypes from 'prop-types';
import EnhancedRaisedButton from 'components/button/EnhancedRaisedButton';
import { Item, Row, Section } from 'components/ui/table/elements';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import { compose } from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';

const StyledLink = styled(Link)`
    padding: .5rem;
    min-width: 88px;
    color: ${ theme.palette.primary1Color };
    font-size: 1rem;
    text-decoration: none;
    text-align: center;

    &:hover,
    &:focus {
        color: ${ theme.palette.primary1ColorHover };
    }
`;
const PasswordForgottenForm = (props) => {
    const {
        handleSubmit,
        handleSubmitForm,
        submitting,
        translate,
    } = props;

    return (
        <form onSubmit={ handleSubmit(handleSubmitForm) }>
            <Section>
                <Row>
                    <Item>
                        <Field
                            component={ RenderTextInputField }
                            disabled={ submitting }
                            label={ translate('auth.forgotPassword.fields.email') }
                            fullWidth={ true }
                            name='email'
                            validate={ [
                                validations.required,
                                validations.email,
                            ] }
                        />
                    </Item>
                </Row>
            </Section>

            <Section>
                <Row>
                    <StyledLink
                        to='/login'
                    >
                        { translate('auth.forgotPassword.actions.iRemember') }
                    </StyledLink>

                    <EnhancedRaisedButton
                        label={ translate('auth.forgotPassword.actions.resetPassword') }
                        disabled={ submitting }
                        primary
                        type='submit'
                    />
                </Row>
            </Section>
        </form>
    );
};

PasswordForgottenForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    translate,
    connect(null, null),
    reduxForm({
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;

            if (!values.email) {
                errors.email = translate('forms.required');
            }

            return errors;
        },
    }),
);

export default enhance(PasswordForgottenForm);



// WEBPACK FOOTER //
// ./src/pages/password-forgotten/PasswordForgottenForm.js